import React, { memo, useCallback, useState } from 'react'
import { CirclePlusMajor } from '@shopify/polaris-icons'
import { Button } from 'src/components/shared/Button'
import { colors } from 'src/theme'
import { CreateTeamRoleModal } from './CreateTeamRoleModal'

interface Props {
  refreshTeamRoles(): Promise<void>
}

const CreateTeamRoleButtonComponent = ({ refreshTeamRoles }: Props) => {
  const [isCreateTeamRoleModalOpen, setIsCreateTeamRoleModalOpen] = useState(false)

  const handleOpenCreateTeamRoleModal = useCallback(() => {
    setIsCreateTeamRoleModalOpen(true)
  }, [])

  const handleCloseCreateTeamRoleModal = useCallback(() => {
    setIsCreateTeamRoleModalOpen(false)
  }, [])

  return (
    <>
      <Button
        size="small"
        fullWidth
        onClick={handleOpenCreateTeamRoleModal}
        color="light"
        endIcon={<CirclePlusMajor width={20} fill={colors.PRIMARY_PURPLE_500} />}
      >
        Add new role
      </Button>
      <CreateTeamRoleModal
        isCreateTeamRoleModalOpen={isCreateTeamRoleModalOpen}
        closeCreateTeamRoleModal={handleCloseCreateTeamRoleModal}
        refreshTeamRoles={refreshTeamRoles}
      />
    </>
  )
}

export const CreateTeamRoleButton = memo(CreateTeamRoleButtonComponent)
